const goToSection = (sectionId: string) => {
  const hash = `#${sectionId}`;
  window.location.hash = hash;
  document.querySelector(hash)?.scrollIntoView();
};

export default goToSection;
